import { HttpErrorResponse } from '@angular/common/http';

export const httpStatusOf = (error: unknown): number => (error instanceof HttpErrorResponse ? error.status : 0);
